import { createContext, createSignal } from "solid-js";
import type { premiumPopUpStoreType } from "../types";
export const createpremiumPopUpStore = (isRuCards = false) => {
	const [getPremiumPopUpStore, setPremiumPopUpStore] = createSignal<premiumPopUpStoreType>({
		isRuCards,
		activePriceIndex: 0,
		activeInterval: "12mo",
		isUnsubscribeQuestionsVisible: false
	});
	return { getPremiumPopUpStore, setPremiumPopUpStore };
};
export const PremiumPopUpContext = createContext<ReturnType<typeof createpremiumPopUpStore>>();
